import {useLocale} from "i18n";
import Seo from "../seo/Seo";
import {ClientServerContent} from "../home/landing/ClientServerContent";
import {clientServerCopy} from "../home/landing/copy/clientServer";

/**
 * Public, pre-rendered **Client-Server (hosted / relay) transfer mode** page (`/client-server`,
 * issue ui#133).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): mounts `<Seo>` + the page body. SEO strings and
 * body copy live in {@link ../home/landing/copy/clientServer.ts}, so a content agent edits only that
 * module and {@link ../home/landing/ClientServerContent.tsx}, never this wrapper. The canonical URL is
 * derived from `path` by `<Seo>` per active locale, so the `/ro` mirror needs no separate wiring.
 */
export function Component() {
	const {locale} = useLocale();
	const {seo} = clientServerCopy[locale];
	return (
		<>
			<Seo title={seo.title} description={seo.description} path="/client-server"/>
			<ClientServerContent/>
		</>
	);
}
